import {Base} from "./base";

class ThirdService extends Base {
  constructor() {
    super();
  }

  /**
   * 获得token
   * @param userId
   * @param {"PAT"} userType
   * @param compatId
   * @returns {Promise<void>}
   */
  async token({userId, userType, compatId}, headers = {thirdId: 5002}) {
    const {code, obj = ''} = await this.$http('smarthos.third.authorization.code.get.v2', {
      userId,
      userType,
      compatId
    }, headers);
    return code === '0' ? obj : '';
  }

  /**
   * 替换链接中带{{token}}
   * @param url
   * @param userId
   * @param compatId
   * @param userType
   * @returns {Promise<*>}
   */
  async replaceTokenInUrl(url, userId, compatId, userType = "PAT") {
    if (url.indexOf('{{token}}') >= 0) {
      return url.replace('{{token}}', await this.token({userId, compatId, userType}));
    }
    return url;
  }

  /**
   * 药事服务专用token
   * @returns {Promise<T>}
   * @constructor
   */
  async RenewalToken() {
    const {code, obj} = await this.$http('smarthos.prescription.accesstoken.get', {})
    if (code === '0') return obj;
    return '';
  }
}

export const thirdService = new ThirdService();



// WEBPACK FOOTER //
// ./src/services/third.js